export interface UpdateAggregationSettingsForOrgResponse {
  affected_rows: number;
}

/**
 * Response for the `recalculateRiskScores` mutation (RSP-6156). The async
 * recompute runs in event-consumers; the data-layer trigger endpoint returns
 * this acknowledgement, surfaced once the request-state-api request resolves.
 */
export interface RecalculateRiskScoresResponse {
  message: string;
}

/**
 * Outcome codes for the `recalculateAppetites` mutation (RSP-6486). `null`
 * means the cascade ran; the two non-null values are *successful* gating
 * outcomes (the org isn't configured for the cascade), surfaced so the UI can
 * show a specific message. Defined as an `as const` object + type alias (not a
 * TS enum) — values match the data-layer processor + legacy GraphQL enum.
 */
export const RecalculateAppetitesErrorCode = {
  CascadeNotConfigured: 'cascade_not_configured',
  CascadeNotEnabled: 'cascade_not_enabled',
} as const;

export type RecalculateAppetitesErrorCode =
  (typeof RecalculateAppetitesErrorCode)[keyof typeof RecalculateAppetitesErrorCode];

/**
 * Response for the `recalculateAppetites` mutation (RSP-6486). Richer than
 * `RecalculateRiskScoresResponse`: the cascade runs server-side in the
 * data-layer endpoint, which returns this body; `executeAsyncRequest` surfaces
 * it once the `AppetitesRecalculated` completion event resolves the request.
 */
export interface RecalculateAppetitesResponse {
  errorCode: RecalculateAppetitesErrorCode | null;
  message: string;
}
